import { createBrowserRouter } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import NotFound from './pages/NotFound';
import ConfigurePage from './pages/ConfigurePage';
import DashboardPage from './pages/DashboardPage';
import InvoicingAndPayrollPage from './pages/InvoicingAndPayrollPage';
import IndexPage from './pages/IndexPage';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './lib/helper/components/PrivateRoute';
import MobileLayout from './components/Layout/MobileLayout';
import Support from './pages/SupportPage';
import InvoicingAndPayrollPastCycles from './pages/InvoiceAndPayroll/PastCycles';
import CaseDetailsPage from './pages/CaseDetailsPage';
import AdminPage from './pages/AdminPage';
import MessagingPage from './pages/MessagingPage';
import ReportingPage from './pages/ReportingPage';
import CompletedCaseDetailsPage from './pages/CompletedCaseDetailsPage';
import Bootstrap from './Bootstrap';
import { AuditCaseDetailsPage } from './pages/AuditCaseDetailsPage';
import AuditPage from './pages/AuditPage';
import LogoutMessagePage from './pages/LogoutMessagePage';

const routes = [
    {
        element: <Bootstrap />,
        children: [
            {
                path: '/login',
                element: <MobileLayout />,
                children: [{ path: '/login', element: <LoginPage /> }]
            },
            {
                path: '/',
                element: <Layout />,
                children: [
                    {
                        path: '/',
                        element: <PrivateRoute />,
                        children: [
                            { path: '/', element: <IndexPage /> },
                            { path: '/dashboard', element: <DashboardPage /> },
                            { path: '/caseDetails/:id/:crmClient', element: <CaseDetailsPage /> },
                            {
                                path: '/completedCaseDetails/:id/:crmClient',
                                element: <CompletedCaseDetailsPage />
                            },
                            { path: '/invoicing-payroll', element: <InvoicingAndPayrollPage /> },
                            {
                                path: '/invoicing-payroll/past-cycles',
                                element: <InvoicingAndPayrollPastCycles />
                            },
                            { path: '/admin', element: <AdminPage /> }
                        ]
                    },
                    {
                        path: '/',
                        element: <PrivateRoute role={['admin']} />,
                        children: [{ path: '/configuration', element: <ConfigurePage /> }]
                    },
                    {
                        path: '/',
                        element: <PrivateRoute role={['admin', 'reporting']} />,
                        children: [{ path: '/reporting', element: <ReportingPage /> }]
                    },
                    {
                        path: '/',
                        element: <PrivateRoute role={['user', 'admin', 'auditing']} />,
                        children: [{ path: '/search', element: <AuditPage /> }]
                    },
                    {
                        path: '/',
                        element: <PrivateRoute role={['user', 'admin', 'auditing']} />,
                        children: [
                            {
                                path: '/search/:id/:crmClient/:isCosign',
                                element: <AuditCaseDetailsPage />
                            }
                        ]
                    },
                    { path: '/support', element: <Support /> },
                    { path: '*', element: <NotFound /> }
                ]
            },
            { path: '/messaging', element: <MessagingPage /> },
            { path: '/logoutMessage', element: <LogoutMessagePage /> }
        ]
    }
];
export default createBrowserRouter(routes);
